import { DataTable } from 'mantine-datatable';
import { useContext, useState, useEffect } from 'react';
import { ExpandedTable } from './ExpandedTable';
import FiltersAndSegmentsContext from '../FiltersAndSegmentsContext';
import { Box, Group, Text, ActionIcon } from '@mantine/core';
import { PRIMARY_BLUE } from '../../../../constants/colors';

export function FiltersAndSegmentsTable() {
  const { filtersTypesArr } = useContext(FiltersAndSegmentsContext)
  const [expandedCompanyIds, setExpandedCompanyIds] = useState<string[]>([]);

  // Debug logging
 

  const handleExpandToggle = (recordId: number) => {
    const recordIdStr = recordId.toString();
    if (expandedCompanyIds.includes(recordIdStr)) {
      setExpandedCompanyIds(expandedCompanyIds.filter(id => id !== recordIdStr));
    } else {
      setExpandedCompanyIds([...expandedCompanyIds, recordIdStr]);
    }
  };

  // If no data, show loading or empty state
  if (!filtersTypesArr || filtersTypesArr.length === 0) {
    return (
      <Box p="xl" style={{ textAlign: 'center' }}>
        <Text color="dimmed">Loading filters...</Text>
      </Box>
    );
  }

  return (
    <Box>
      <DataTable
        height="calc(100vh - 280px)"
        withColumnBorders
        highlightOnHover
        columns={[
          {
            accessor: 'filter-name',
            title: (
              <Group spacing="xs">
                <Text weight={600}>FILTER NAME</Text>
              </Group>
            ),
            noWrap: true,
            width: 250,
            render: ({ id, name }) => (
              <Group spacing="sm">
                <ActionIcon 
                  size="sm" 
                  variant="subtle" 
                  color="blue"
                  className="expand-button"
                  onClick={() => handleExpandToggle(id)}
                >
                  {expandedCompanyIds.includes(id) ? (
                    <Text size="xs" color={PRIMARY_BLUE}>▼</Text>
                  ) : (
                    <Text size="xs" color={PRIMARY_BLUE}>▶</Text>
                  )}
                </ActionIcon>
                <Text weight={500} className="filter-name-cell">{name}</Text>
              </Group>
            ),
          },
          {
            accessor: 'ideas-idea',
            title: (
              <Text weight={600} size="sm">IDEAS PAGE & IDEA VIEW</Text>
            ),
            noWrap: true,
            width: 220,
            render: ({ id, name }) => (
              <Box>
                <Text size="sm" color="dimmed" className="filter-description">
                  
                </Text>
              </Box>
            ),
          },
          { 
            accessor: 'perspective', 
            title: (
              
              <Text weight={600} size="sm">PERSPECTIVES</Text>
           
            ), 
            width: 200,
            render: ({ id, name }) => (
              <Box>
                <Text size="sm" color="dimmed" className="filter-description">
                  
                </Text>
              </Box>
            ),
          },
          { 
            accessor: 'customer360', 
            title: (
              <Text weight={600} size="sm">C360 PAGE</Text>
            ), 
            width: 200,
            render: ({ id, name }) => (
              <Box>
                <Text size="sm" color="dimmed" className="filter-description">
                 
                </Text>
              </Box>
            ),
          },
        ]}
        records={filtersTypesArr}
        rowExpansion={{
          allowMultiple: true,
          expanded: { recordIds: expandedCompanyIds, onRecordIdsChange: setExpandedCompanyIds },
          content: (filterObj) => (
            <ExpandedTable companyId={filterObj.record.id} />
          ),
        }}
      />
    </Box>
  );
}